<div class="pos-r padding-24" *ngIf="loading">
  <app-loader></app-loader>
</div>
<div *ngIf="!loading">
  <app-tickets-period-filter [ticketsPeriodFilter]="ticketsPeriodFilter"> </app-tickets-period-filter>

  <div class="filter-assign__wrapper" #filterAssignWrapper>
    <div class="filter-assign__container" #filterAssignContainer>
      <ng-container *ngIf="ticketsPage; else mapFilters">
        <ng-container *ngIf="isGRSUser(); else ticketsFilter">
          <app-tickets-grs-filter
            [ticketsPeriodFilter]="ticketsPeriodFilter"
            [ticketsMultipleAssign]="ticketsMultipleAssign"
            [ticketsCurrentFilter]="ticketsCurrentFilter"
            [tickets]="tickets"
            [brigadeAssign]="brigadeAssignData"
          ></app-tickets-grs-filter>
        </ng-container>
      </ng-container>

      <ng-template #ticketsFilter>
        <app-tickets-current-filter [ticketsCurrentFilter]="ticketsCurrentFilter" [brigadeAssign]="brigadeAssignData"> </app-tickets-current-filter>
        <app-tickets-multiple-assign [ticketsMultipleAssign]="ticketsMultipleAssign"> </app-tickets-multiple-assign>
      </ng-template>
      <ng-template #mapFilters>
        <app-tickets-map-filter [ticketsCurrentFilter]="ticketsCurrentFilter" [brigadeAssign]="brigadeAssignData"> </app-tickets-map-filter>
        <div class="filter-assign__map-selection">
          <button
            type="button"
            class="button"
            [class.filter-assign__map-selection-button--active]="ticketsMultipleAssign.isMapSelectionMode"
            (click)="ticketsMultipleAssign.onToggleMapSelectionMode()"
          >
            {{ ticketsMultipleAssign.isMapSelectionMode ? 'Выйти из режима выбора' : 'Выбрать заявки' }}
          </button>
          <span class="filter-assign__map-selection-count" *ngIf="ticketsMultipleAssign.isMapSelectionMode">
            Выбрано: {{ (ticketsMultipleAssign.ticketsChecked && ticketsMultipleAssign.ticketsChecked.length) || 0 }}
          </span>
        </div>
        <app-tickets-multiple-assign
          *ngIf="ticketsMultipleAssign.isMapSelectionMode"
          [ticketsMultipleAssign]="ticketsMultipleAssign"
        ></app-tickets-multiple-assign>
      </ng-template>
    </div>
  </div>

  <ng-container *ngIf="ticketsCurrentFilter.mode === 'table'">
    <ng-container *ngIf="!isGRSUser(); else grsList">
      <app-tickets-list
        [brigadeAssign]="brigadeAssignData"
        [filter]="parentParams"
        [ticketsCurrentFilter]="ticketsCurrentFilter"
        [ticketsPeriodFilter]="ticketsPeriodFilter"
        [ticketsMultipleAssign]="ticketsMultipleAssign"
        [tickets]="tickets"
      ></app-tickets-list>
    </ng-container>
    <ng-template #grsList>
      <app-tickets-grs-list
        [brigadeAssign]="brigadeAssignData"
        [filter]="parentParams"
        [ticketsCurrentFilter]="ticketsCurrentFilter"
        [ticketsPeriodFilter]="ticketsPeriodFilter"
        [ticketsMultipleAssign]="ticketsMultipleAssign"
        [tickets]="tickets"
      ></app-tickets-grs-list>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="ticketsCurrentFilter.mode === 'matrix'">
    <app-tickets-matrix
      [brigadeAssign]="brigadeAssignData"
      [filter]="parentParams"
      [ticketsCurrentFilter]="ticketsCurrentFilter"
      [ticketsPeriodFilter]="ticketsPeriodFilter"
      [ticketsMultipleAssign]="ticketsMultipleAssign"
      [tickets]="tickets"
    ></app-tickets-matrix>
  </ng-container>

  <ng-container *ngIf="ticketsCurrentFilter.mode === 'map'">
    <app-tickets-map
      class="filter-assign__map"
      [brigadeAssign]="brigadeAssignData"
      [filter]="parentParams"
      [ticketsCurrentFilter]="ticketsCurrentFilter"
      [ticketsPeriodFilter]="ticketsPeriodFilter"
      [ticketsMultipleAssign]="ticketsMultipleAssign"
      [tickets]="tickets"
    ></app-tickets-map>
  </ng-container>
</div>
